import { BUSINESS_TYPES } from './types';

// { label: 'Automotive', value: 'Automotive' },
// { label: 'Fitness', value: 'Fitness' },
// { label: 'Grocery', value: 'Grocery' },
// { label: 'Hotel', value: 'Hotel' },
// { label: 'Medical Offices', value: 'Medical Offices' },
// { label: 'Restaurants', value: 'Restaurants' },
// { label: 'Retail Stores', value: 'Retail Stores' },
// { label: 'Spas', value: 'Spas' },
// { label: 'Other', value: 'Other' },
const CHECK_ORDER = [
  'Automotive',
  'Fitness',
  'Grocery',
  'Spas',
  'Hotel',
  'Medical Offices',
  'Restaurants',
  'Retail Stores',
];

const BUSINESS_TYPE_KEYWORDS: Record<string, Set<string>> = {
  Automotive: new Set(['auto', 'car']),
  Fitness: new Set(['fitness', 'gym', 'yoga', 'sports']),
  Grocery: new Set(['supermarket', 'grocery']),
  Spas: new Set(['spa', 'massage', 'nail', 'hair', 'beauty', 'salon']),
  Hotel: new Set(['hotel', 'motel', 'lodging']),
  'Medical Offices': new Set(['medical', 'doctor', 'hospital', 'clinic', 'health', 'dentist']),
  Restaurants: new Set([
    'restaurant',
    'food',
    'dining',
    'bar',
    'pub',
    'cafe',
    'coffee',
    'breakfast',
    'lunch',
    'dinner',
    'brunch',
  ]),
  'Retail Stores': new Set(['store', 'shop', 'retail']),
};

export function getBusinessType(tags: string[]) {
  const lowerTags = tags.map((tag) => new Set(tag.toLowerCase().split(' ')));
  for (const businessType of CHECK_ORDER) {
    const keywords = BUSINESS_TYPE_KEYWORDS[businessType];
    if (!keywords) {
      continue;
    }
    for (const tag of lowerTags) {
      if (keywords.intersection(tag).size > 0) {
        return businessType;
      }
    }
  }
  return undefined;
}
